<template>
  <div class='houseType'>
    <!-- 户型 -->
    <div class="selectOption">
      <div class="selectOptionBox">
        <template v-for="(item, index) in house_type_options">
          <div :class="['selectOptionItem', { active: search.house_type == item }]" :key="index" @click="selectOption(item, 'house_type')">
            <span class="name">{{item}}</span>
          </div>
        </template>
      </div>
    </div>
    <!-- 面积范围 -->
    <div class="selectOption">
      <div class="selectOptionBox">
        <template v-for="(item, index) in area_type_options">
          <div :class="['selectOptionItem', { active: search.area_type == item }]" :key="index" @click="selectOption(item, 'area_type')">
            <span class="name">{{item}}</span>
          </div>
        </template>
      </div>
    </div>
    <div class="case-list" id="caseList">
      <div class="case-item" v-for="(item, index) in houseList" :key="index" @click="selectHouse(item)">
        <div :class="['case-pic', {active: house_id == item.id}]">
          <img :src="item.title_pic" alt="">
        </div>
        <div>{{ item.house_name }} </div>
      </div>
    </div>
    <div v-if="isFinished" class="finished">没有更多</div>
    <div v-if="loading" class="finished">
      加载中
      <i class="el-icon-loading"></i>
    </div>
    <div :class="['submit-box', { 'absolute': isAbsolute }]" v-if="house_id && showBtn">
      <span :class="['submit', {show: house_id}]" @click="goRoom">完成</span>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
const md5 = require('js-md5')
import qs from 'qs'
export default {
  name: 'houseType',
  components:{ 
  },
  data() {
    return {
      house_type_options: [],
      area_type_options: [],
      houseList: [],
      search: {
        house_type: '',
        area_type: ''
      },
      loading: false,
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      house_id: '',
      isFinished: false,
      isClick: false,
      isAbsolute: false,
      showBtn: false
    }
  },
  computed:{
  },
  watch:{ },
  created() {
    this.getHouseType()
    this.getAreaType()
    const {area_type, house_type, house_id} = sessionStorage
    area_type && (this.search.area_type = area_type)
    house_type && (this.search.house_type = house_type)
    house_id && (this.house_id = house_id)
    this.getHouseList()
    sessionStorage.removeItem('area_type')
    sessionStorage.removeItem('house_type')
    sessionStorage.removeItem('house_id')
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
     getHouseType() {
      axios.get('/interface/dictionary?type=house').then((res) => {
        this.house_type_options = res.data
      }).catch((err) => {
        this.$message.error(err.msg)
      })
    },
    getAreaType() {
      axios.get('/interface/dictionary?type=area').then((res) => {
        this.area_type_options = res.data
        console.log('getareaType', res)
      }).catch((err) => {
        this.$message.error(err.msg)
      })
    },
    onScroll() {
      const target = document.getElementById('caseList');
      const targetRect = target.getBoundingClientRect();
      const distanceFromBottom = window.innerHeight - targetRect.bottom;
      if (distanceFromBottom > 0 && !this.isFinished) {
        this.getHouseList(); // 滚动到底部时加载数据
      }
      this.AbsoluteBtn()
    },
    AbsoluteBtn() {
      const target = document.getElementById('caseList');
      const targetRect = target.getBoundingClientRect();
      const distanceFromBottom = window.innerHeight - targetRect.bottom;
      const targetItem = document.getElementsByClassName('case-item')
      if (targetItem && targetItem.length > 0) {
        const targetItemRect = targetItem[0].getBoundingClientRect()
        if (targetRect.top >= window.innerHeight - (targetItemRect.height / 3)) {
          this.showBtn = false
        } else {
          this.showBtn = true
        }
      }
      if (distanceFromBottom <= 0) {
        this.isAbsolute = false
      } else {
        this.isAbsolute = true
      }
    },
    getHouseList() {
      if (this.isFinished || this.loading) return
      this.loading = true
      console.log(this.isFinished,  this.loading)
      const stamp = Date.now()
      const key = atob(localStorage.getItem('okey'))
      const { area_type, house_type } = this.search
      const { pageNum, pageSize } = this.page
      axios.get('/interface/searchRenewHouseType', {
        params: {
          area_type,
          house_type,
          pageNum,
          pageSize,
          is_hidden: 0,
          is_hot: '',
          token: this.token,
          stamp,
          sign: md5(`${stamp}${pageNum}${pageSize}${key}`)
        }
      }).then((res) => {
        console.log('getHouseList', res)
        this.houseList.push(...res.data.data)
        this.page.pageNum++
        console.log(res)
        if (res.data.data.length === 0) {
          this.isFinished = true;
        }
        if (this.houseList.length >= res.data.total) {
          this.isFinished = true
        }
        this.loading = false;
      })
    },
    selectOption(item, key) {
      this.house_id = ''
      if (key === 'house_type') {
        this.search.area_type = ''
      }
      this.search[key] = this.search[key] === item ? '' : item
      this.page.pageNum = 1
      this.houseList = []
      this.isFinished = false
      this.getHouseList()
    },
    selectHouse(item) {
      this.house_id = item.id
      this.AbsoluteBtn()
    },
    goRoom() {
      // if (!localStorage.getItem('giftsUser')) {
      //   this.$parent.$parent.$emit('needLogin', true)
      //   return false
      // }
      // this.saveBrowsHistory()
      sessionStorage.setItem('area_type', this.search.area_type)
      sessionStorage.setItem('house_type', this.search.house_type)
      sessionStorage.setItem('house_id', this.house_id)
      this.$emit('next', this.house_id)
    },
    saveBrowsHistory() {
      console.log('saveBrowsHistory')
      const stamp = Date.now()
      const user_id = localStorage.getItem('giftsUser') ? JSON.parse(localStorage.getItem('giftsUser')).id : ''
      const nick = localStorage.getItem('giftsUser') ? JSON.parse(localStorage.getItem('giftsUser')).nick : ''
      const token = localStorage.getItem('token')
      const key = atob(localStorage.getItem('key'))
      const { area_type, house_type } = this.search
      const { house_name, house_desc, title_pic } = this.houseList.filter(item => item.id === this.house_id)[0]
      const data = {
        user_id,
        nick,
        house_id: this.house_id,
        house_name,
        house_desc,
        house_type,
        area_type,
        title_pic,
        sort: 0,
        is_hot: '',
        token: token,
        stamp,
        sign: md5(`${stamp}${token}${user_id}${key}`)
      }
      axios.post('/interface/saveBrowsHistory', qs.stringify(data)).then((res) => {
        console.log(res.msg)
      })
    },
  }
}
</script>
<style lang='less' scoped>
.houseType {
  background: #fff;
  padding: 20px 0 150px;
  position: relative;
  .selectOption {
    width: 100%;
    overflow: auto;
    padding: 10px 237px;
    &::-webkit-scrollbar {
      display: none!important;
    }
    .selectOptionBox {
      display: flex;
      flex-wrap: nowrap;
      .selectOptionItem {
        padding: 14px 28px;
        font-size: 28px;
        font-weight: 400;
        color: #333333;
        border-radius: 24px;
        border: 1px solid transparent;
        .name {
          display: block;
          white-space: nowrap;
          font-weight: 400;
          font-size: 22px;
          color: #999999;
        }
        &.active {
          border-color: #009538;
          .name {
            color: #333333;
          }
        }
      }
    }
  }
  .case-list {
    width: 1445px;
    padding-top: 13px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin: 0 auto;
    .case-item {
      width: 311px;
      height: 400px;
      background: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      margin-bottom: 30px;
      &:nth-child(4n - 2) {
        margin-left: 67px; 
      }
      &:nth-child(4n - 1) {
        margin: 0 67px; 
      }
      .case-pic {
        width: 311px;
        height: 312px;
        border-radius: 26px;
        border: 2px solid #D9D9D9;
        margin-bottom: 20px;
        display: flex;
        justify-content: center;
        align-content: center;
        overflow: hidden;
        &.active {
          border-color: #009538;
        }
        img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
        }
      }
      div {
        width: 100%;
        height: 32px;
        line-height: 30px;
        margin-top: 10px;
        font-size: 22px;
        font-family: FZLanTingHeiS-R-GB;
        font-weight: 400;
        color: #333333;
        white-space: nowrap;
        // overflow: hidden;
        // text-overflow: ellipsis;
      }
    }
  }
  .submit-box {
    width: 100%;
    height: 66px;
    padding: 0 19px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 0;
    bottom: 30px;
    position: fixed;
    &.absolute {
      position: absolute!important;
      bottom: 20px;
    }
    .submit {
      width: 466px;
      height: 66px;
      line-height: 66px;
      background: #F0F7F0;
      font-weight: 400;
      font-size: 24px;
      display: block;
      color: #CCCCCC;
      text-align: center;
      cursor: pointer;
      user-select: none;
      &.show {
        color: #FFFFFF;
        background: #009538;
      }
    }
  }
  .finished {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: #999;
  } 
}
</style>